import React from "react"
import Link from "gatsby-link"
import { Helmet } from "react-helmet"
import Markdown from "../../components/Markdown"
import * as PropTypes from "prop-types"

import style from "./index.module.css";

const propTypes = {
  data: PropTypes.object.isRequired,
}

class About extends React.Component {
  render() {
    const content = this.props.data.page.edges[0].node
    return (
      <div className={style.main}>
        <Helmet>
          <title>{content.title}</title>
          <meta name="description" content={content.metaDescription} />
          <meta property="og:title" content={content.title} />
          <meta property="og:description" content={content.metaDescription} />
        </Helmet>
        <div className={style.imageContainer}>
          {content.image &&
            <img
              className={style.image}
              src={`${content.image.file.url}?w=300`}
              srcSet={`
                  ${content.image.file.url}?w=300 300w,
                  ${content.image.file.url}?w=410 410w,
                  ${content.image.file.url}?w=615 615w,
                  ${content.image.file.url}?w=820 820w
                `}
            />
          }
        </div>
        <div className={style.content}>
          {content.title &&
            <h1 className={style.title}>{content.title}</h1>
          }
          {content.intro &&
            <Markdown className={style.intro} source={content.intro.intro} />
          }
          {content.body &&
            <Markdown className={style.body} source={content.body.body} />
          }
        </div>
      </div>
    )
  }
}

About.propTypes = propTypes

export default About

export const pageQuery = graphql`
  query PageQuery {
    page: allContentfulPageAbout {
      edges {
        node {
          id
          title
          metaDescription
          image {
            file {
              url
            }
          }
          body {body}
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/over/index.js